import {BaseApi} from './base.api';

export const DashboardApi = {
  getMyDashboard,
  getDefectSummary
};

function getMyDashboard(){
  return BaseApi.get('/dashboard/navigation');
}

function getDefectSummary(examineReportId){
  return BaseApi.get(`/dashboard/defects/summary/${examineReportId}`);
}
